import React, { FunctionComponent } from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { atelierSulphurpoolLight } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import styled from 'styled-components';

const DocsPageContentCode: FunctionComponent = ({ children }) =>
{
    return <DocsPageContentCodeWrapper children={children} language={'text'} style={atelierSulphurpoolLight}/>;
};

export default DocsPageContentCode;

const DocsPageContentCodeWrapper = styled( SyntaxHighlighter )`
  display: inline !important;

  margin-right: 3px !important;
  padding: 1px 5px !important;

  font-size: 12.5px !important;

  border-radius: 4px;
`;
